export default __webpack_public_path__ + "static/media/reach-map.daca9197.svg";